import { z } from 'zod';
import { BuyerResearchStage } from './BuyerResearchStage';
export var ContentType;
(function (ContentType) {
    ContentType["Unspecified"] = "Unspecified";
    ContentType["EBook"] = "eBook";
    ContentType["Guide"] = "Guide";
    ContentType["WhitePaper"] = "White Paper";
    ContentType["Checklist"] = "Checklist";
    ContentType["ResearchReport"] = "Research Report";
    ContentType["CaseStudy"] = "Case Study";
    ContentType["SlideShow"] = "Slide Show";
    ContentType["Infographic"] = "Infographic";
    ContentType["AdCreative"] = "Ad Creative";
    ContentType["Image"] = "Image";
    ContentType["AccountsList"] = "Accounts List";
})(ContentType || (ContentType = {}));
export var PreferredChannel;
(function (PreferredChannel) {
    PreferredChannel["Unspecified"] = "Unspecified";
    PreferredChannel["SocialMedia"] = "Social Media";
    PreferredChannel["SalesOutreachEmail"] = "Sales Outreach Email";
    PreferredChannel["ContentSyndication"] = "Content Syndication";
    PreferredChannel["AdSolutions"] = "Ad Solutions";
})(PreferredChannel || (PreferredChannel = {}));
export const DraftAsset = z.object({
    id: z.number(),
    name: z.string(),
    downloadUrl: z.string().url(),
    companyId: z.number(),
    uploadedAt: z.string(),
    uploadedBy: z.number(),
    uploadedByDisplayName: z.string(),
});
export const ReviewedAsset = z.object({
    id: z.number(),
    name: z.string().min(1, {
        message: 'Please enter a name for the asset',
    }),
    downloadUrl: z.string().url(),
    campaigns: z
        .object({ id: z.number(), name: z.string() })
        .array()
        .max(8, { message: 'Please select up to 8 intent models' }),
    companyId: z.number(),
    contentType: z.enum(ContentType, {
        error: 'Please select content type',
    }),
    buyerResearchStages: z
        .enum(BuyerResearchStage, {
        error: 'Please select BRS stage',
    })
        .array(),
    preferredChannel: z.enum(PreferredChannel, {
        error: 'Please select preferred channel',
    }),
    reviewedAt: z.string(),
    reviewedBy: z.number(),
    reviewedByDisplayName: z.string(),
    updatedAt: z.string().nullable(),
    uploadedBy: z.number().nullable(),
    uploadedByDisplayName: z.string().nullable(),
});
export const ReviewedAssetUpdate = ReviewedAsset.pick({
    name: true,
    campaigns: true,
    contentType: true,
    preferredChannel: true,
    buyerResearchStages: true,
});
export const ReviewedAssetPartialUpdate = ReviewedAssetUpdate.partial().refine((data) => !Object.values(data).every((value) => value === undefined), { message: 'Please update at least one field', path: ['general'] });
//# sourceMappingURL=ContentLibrary.js.map